import { Scene } from 'phaser';
import EDC from '@/components/games/shared/globals';
import store from '@/store';

class SiteMenuPreloaderScene extends Scene {
  isAllLoaded = false;

  create() {
    this.load.on('complete', this.loadingComplete, this);

    const activeAccount = store.getters['children/activeChildProfile'];

    const customFont = new FontFace(
      'font009',
      'url(https://s3.amazonaws.com/images.growmindgrow/phaser-assets/fonts/font009.otf)',
      {
        style: 'normal',
        weight: 'normal',
      },
    );
    document.fonts.add(customFont);
    customFont.load().then(() => {
      this.loadingComplete();
    });

    this.load.setPath('https://images.growmindgrow.com/play-site-menu/');
    this.load.setPrefix('site-menu-');

    this.load.image('avatar-frame', 'AvatarFrame.png');
    this.load.image('home-link', 'Label_Home.png');
    this.load.image('home-icon', 'Icon_Home.png');
    this.load.image('about-link', 'Label_About.png');
    this.load.image('about-icon', 'Icon_About.png');
    this.load.image('mainmenu-link', 'Label_MainMenu.png');
    this.load.image('mainmenu-icon', 'Icon_MainMenu.png');
    this.load.image('restart-link', 'Label_Restart.png');
    this.load.image('restart-icon', 'Icon_Restart.png');
    this.load.image('link-frame', 'FrameMid.png');
    this.load.image('link-frame-left', 'FrameLeft.png');
    this.load.image('link-frame-right', 'FrameRight.png');
    this.load.image('link-frame-light', 'FrameMid_Hover.png');
    this.load.image('link-frame-left-light', 'FrameLeft_Hover.png');
    this.load.image('link-frame-right-light', 'FrameRight_Hover.png');
    this.load.image('sound-on-icon', 'Icon_Sound.png');
    this.load.image('sound-off-icon', 'Icon_SoundOff.png');
    this.load.image('name-frame-left', 'Name_Left.png');
    this.load.image('name-frame-right', 'Name_Right.png');
    this.load.image('name-frame', 'Name_Mid.png');
    this.load.image('owl', 'AssignmentOwl.png');
    this.load.image('exit-btn', 'ExitButton.png');

    this.load.setPath('https://images.growmindgrow.com/play-site/parent-assignments/');
    for (let i = 0; i <= 9; i++) {
      this.load.image(`num-${i}`, `Num_${i}.png`);
    }
    this.load.image('more-than-nine', 'NumMoreThan_9.png');

    if (activeAccount && activeAccount.avatar) {
      this.load.setPath('https://images.growmindgrow.com/avatars/');
      this.load.image('account-image', activeAccount.avatar);
    }

    this.load.setPath();
    this.load.setPrefix();
    this.load.start();
  }

  loadingComplete() {
    this.onLoadImagesComplete();
    this.isAllLoaded = true;
  }

  onLoadImagesComplete() {
    if (this.isAllLoaded) {
      this.load.off(this.onLoadImagesComplete, this);
      this.scene.start('main');
    }
  }
}

EDC.Preloaders.SiteMenu = SiteMenuPreloaderScene;

export default SiteMenuPreloaderScene;
